import React from "react";
import {ComponentType} from "react";
import {FormFieldProps} from "../components/form/Form/Form";
import classNames from "classnames";
import AlertLabel from "../components/AlertLabel/AlertLabel";
import {themeColors} from "../styles/theme";
import {useTheme} from "../context/themeContext";


type FieldWithLabelProps = {
    inline?: boolean;
    alertLabel?: string;
    visible?: boolean;
}

//eslint-disable-next-line
const withClass = <P extends {}>(
    Wrapped: ComponentType<P>,
    className: string
) => {
    return (props: P) => (
        <div className={className}>
            <Wrapped {...props} />
        </div>
    );
};

const FieldWithLabel = <P extends FormFieldProps>(Wrapped: ComponentType<P>) => {
    return React.forwardRef<HTMLElement, P & FieldWithLabelProps>(({inline, alertLabel, visible = true, ...props},
                                                                   ref) => {
        const {theme} = useTheme();

        const fieldGroupClassname = classNames(
            'form-field-group',
            inline && 'inline',
            props.fieldGroupClassName && props.fieldGroupClassName
        );

        return (
            <>
                {
                    visible ?
                        <label
                            className={fieldGroupClassname}
                            style={
                                theme === 'light' ? {color: themeColors.navyBlue} : {
                                    color: themeColors.white
                                }}
                        >
                            <div className="label-group">
                                <span>{props.label ?? props.name}</span>
                                {
                                    props.required
                                        ? <span style={{color: themeColors.invalidColor1}}>*</span>
                                        : null
                                }
                                {
                                    alertLabel && <AlertLabel text={alertLabel}/>
                                }
                            </div>
                            <Wrapped
                                {...props as any}
                                ref={ref}
                            />
                        </label>
                        : null
                }
            </>
        )
    });
};

export {FieldWithLabel};
